module.exports = __webpack_public_path__ + "img/Loader.d05011b2.png";